import React from "react";

function TopicData({ topicData }) {
  console.log(topicData);
  return (
    <div className="topic-data-box">
      <h1>{topicData.topicData.heading}</h1>
      <div className="topic-data">
        <h6>{topicData.topicData.subHeading}</h6>
        <p>{topicData.topicData.text}</p>
      </div>
    </div>
  );
}

export default TopicData;
